import { Injectable } from '@zhfe/vue2-di-plugin'
import Axios, { AxiosInstance } from 'axios'
import fetcher, { request } from '@/api/fetcher/request'
import client from '@/client/modules/common'

export class ResponseError extends Error {
  name = 'ResponseError'
  constructor (public responseBody: any, public requestUrl: string, msg?: string) {
    super(msg)
  }
}

export interface QueryParams {
  [key: string]: number | boolean | string | Array<number | boolean | string>;
}

export interface ResponseCommon {
  ret: 0 | 1
  msg: string
}

@Injectable()
export class HttpService {
  private axios: AxiosInstance
  constructor () {
    this.axios = Axios.create({
      baseURL: fetcher.defaults.baseURL,
      timeout: fetcher.defaults.timeout
    })
    /** 请求拦截 */
    this.axios.interceptors.request.use(request.success, request.error)
    /** 响应拦截 */
    this.axios.interceptors.response.use((response: any) => {
      const body = response.data
      body.resp_common = body.resp_common || {}
      const { ret, msg } = body?.resp_common || {}
      // copy 自原来的 代码 start
      if (ret === 4001002) {
        // @ts-ignore
        const name = window.app.$route.name
        if (name !== 'login' && name !== 'login2' && name !== 'login3') {
        // @ts-ignore
          window.app.$toast('登录信息已过期，请重新登录')
          // @ts-ignore
          window.app.$store.dispatch('user/setLoginStatus', 2)
          // @ts-ignore
          client.API.exit()
          // @ts-ignore
          window.app.$EventBus.$emit('logout')
        }
      }
      // copy 自原来的 代码 end

      if (ret === 0) {
        return body
      }

      return Promise.reject(new ResponseError(body?.resp_common, response.config?.url, body.resp_common?.msg || '未知错误！'))
    })
  }

  get<T, CustomResponseCommon = {}> (
    url: string,
    params: QueryParams = {}
  ): Promise<T & { resp_common: ResponseCommon & CustomResponseCommon }> {
    return this.axios.get(url, {
      params
    }) as Promise<any>
  }

  post<T, CustomResponseCommon = {}> (
    url: string,
    data: any
  ): Promise<T & { resp_common: ResponseCommon & CustomResponseCommon }> {
    const params = {
      ...(data || {})
    }
    return this.axios.post(url, params) as Promise<any>
  }
}
